import { DownloadFormatEnum } from '@shared/components/download-button/download-button.model';


// ENUMS #######################################################################
export enum ResultActionIdentifierEnum {
	CLOSE = 'close',
	CONFIRM = 'confirm',
	DOWNLOAD = 'download'
}

export enum ResultViewPlacementEnum {
	AFTER_MESSAGE = 'afterMessage',
	AFTER_NOTICE = 'afterNotice',
	BEFORE_MESSAGE = 'beforeMessage',
	BEFORE_NOTICE = 'beforeNotice'
}

// INTERFACES ##################################################################
// Base
/**
 * use absolute paths
 */
export interface IResultI18n {
	/**
	 * Contains data for dynamic rendering of additional individually styled text
	 */
	additionalFormattedDescriptions?: IResultFormattedDescription[];
	message: string;
	notice?: string;
}

interface IResultActionEventBase {
	identifier: ResultActionIdentifierEnum;
}

export interface IResultActionEventClose extends IResultActionEventBase {
	identifier: ResultActionIdentifierEnum.CLOSE;
}

export interface IResultActionEventConfirm extends IResultActionEventBase {
	identifier: ResultActionIdentifierEnum.CONFIRM;
}

export interface IResultActionEventDownload extends IResultActionEventBase {
	identifier: ResultActionIdentifierEnum.DOWNLOAD;
	downloadFormat: DownloadFormatEnum;
}

interface IResultActionConfigBase {
	identifier: ResultActionIdentifierEnum;
	isDisabled?: boolean;
}

export interface IResultActionConfigClose extends IResultActionConfigBase {
	identifier: ResultActionIdentifierEnum.CLOSE;
}

export interface IResultActionConfigConfirm extends IResultActionConfigBase {
	identifier: ResultActionIdentifierEnum.CONFIRM;
}

export interface IResultActionConfigDownload extends IResultActionConfigBase {
	identifier: ResultActionIdentifierEnum.DOWNLOAD;
	supportedDownloadFormats: DownloadFormatEnum[];
}

export interface IResultConfig {
	actions?: ResultActionConfigType[];
	allowCopyToClipboard?: boolean;
	i18n: IResultI18n;
	showIcon?: boolean;
	result: string;
}

export interface IResultFormattedDescription {
	i18n: string;
	order: number;
	placement: ResultViewPlacementEnum;
	styleClass?: string;
}


// Modal
export interface IResultModalI18n extends IResultI18n {
	title: string;
}

export interface IResultModalConfig extends Omit<IResultConfig, 'actions'> {
	actionsView?: ResultActionConfigType[];
	actionsModal?: ResultActionConfigType[];
	i18n: IResultModalI18n;
	/**
	 * allows rendering of 'close/abort' button (x) in header
	 */
	isDismissible?: boolean;
	/**
	 * blocks creation of a default close modal action, when actionsModel is empty
	 */
	noDefaultCloseAction?: boolean;
}


// TYPES #######################################################################
export type FormattedDescriptionsMapValueType = Omit<IResultFormattedDescription, 'placement'>[];

export type FormattedDescriptionsMapType = Map<ResultViewPlacementEnum, FormattedDescriptionsMapValueType>;

export type ResultActionEventType =
	IResultActionEventClose |
	IResultActionEventConfirm |
	IResultActionEventDownload;

export type ResultActionConfigType =
	IResultActionConfigClose |
	IResultActionConfigConfirm |
	IResultActionConfigDownload;
